import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import {
  getTeamTask,
} from "../../../../../redux/team/action";
import TeamsAddTaskModel from "../TeamsModels/TeamsAddTaskModel";
import TeamsMilestoneModel from "../TeamsModels/TeamsMilestoneModel";
import { Modal } from "reactstrap";
import TeamsViewDetailsModel from "../TeamsModels/TeamsViewDetailsModel";
import { getDateFormate } from "../../../../Common/AllDateTimeReleventFormate";
import ReactSelect from "react-select";
import ProfilePic from "../../../../../assests/imgs/Profileplaceholder.svg";


export default function TeamsProjectDetails({
  projectid,
  setProjectID,
  projectdetails,
  setProjectdetails,
}) {
  const [searchtext, setSearchtext] = useState("");
  const [debouncedSearchtext, setDebouncedSearchtext] = useState(searchtext);
  const [selectedOption, setselectedOption] = useState("");
  const [selectedOptionid, setselectedOptionid] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const getallteamtaskslist = useSelector(
    ({ team: { getteamtasks } }) => getteamtasks
  );
  const dispatch = useDispatch();

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchtext(searchtext);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchtext]);

  useEffect(() => {
    dispatch(getTeamTask(projectid, selectedOptionid, debouncedSearchtext));
  }, [debouncedSearchtext, dispatch, selectedOptionid]);

  const [taskdetails, setTaskDetails] = useState(false);
  const [itemdata, setitemdata] = useState(false);
  const [taskmodel, setTaskModel] = useState(false);
  const [milestonemodel, setMilestoneModel] = useState(false);
  const [viewmodel, setviewModel] = useState(false);

  const options = [
    { value: "1", label: "Created On (Newest First)" },
    { value: "2", label: "Created On (Oldest First)" },
    { value: "3", label: "Status (Higest to Lowest)" },
    { value: "4", label: "Status (Lowest to Highest)" },
    { value: "5", label: "Due Date (Earliest First)" },
    { value: "6", label: "Due Date (Earliest Last)" },
    { value: "7", label: "Title (A to Z)" },
    { value: "8", label: "Title (Z to A)" },
    { value: "9", label: "Priority (Lowest First)" },
    { value: "10", label: "Priority (Higest First)" },
  ];

  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  useEffect(() => {
    if (taskmodel || milestonemodel) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [taskmodel, milestonemodel]);

  const handleOpenAccordion = (aid) => {
    if (selectedCategory === aid) {
      setSelectedCategory("");
    } else {
      setSelectedCategory(aid);
    }
  };

  return (
    <>
      <div className=" manage-team ">
        <button
          className="buttons border-button manage-back-btn"
          onClick={() => {
            setProjectID(0);
            setProjectdetails(null);
          }}
        >
          <i class="fa-solid fa-arrow-left" aria-hidden="true"></i> Back
        </button>
        <div className="manageteam-left">
          <h6 className="tickr-ltd"> {projectdetails?.title}</h6>
          <div className="manage-right">
            <div className="search-bar w-auto">
              <input
                type="search"
                onChange={(e) => setSearchtext(e.target.value)}
                placeholder="Search expert"
                className="form-control"
              />
              <button className="btn search-btn">
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/common/search-lg.svg`}
                  alt=""
                />
              </button>
            </div>
            {profile?.role_type == 4 && (
              <>
                <a
                  onClick={() => setMilestoneModel(true)}
                  className="buttons border-button"
                >
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/plus.svg`}
                    alt=""
                  />
                  Milestone
                </a>
                <a
                  onClick={() => setTaskModel(true)}
                  className="buttons background-button"
                >
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/plus.svg`}
                    alt=""
                  />
                  Add task
                </a>
              </>
            )}
          </div>
        </div>

        <div className="row invite-row">
          <div className="col-md-6">
            <h6>
              Total Tasks: {projectdetails?.task}
            </h6>
          </div>
          <div className="col-md-6 invite-flex">
            <div className="select-flex">
              <p>Sort by :</p>
              <ReactSelect
                value={selectedOption}
                onChange={(option) => {
                  setselectedOptionid(option.value);
                  setselectedOption(option);
                }}
                options={
                  Array.isArray(options)
                    ? options.filter((opt) => opt.value !== selectedOption?.value)
                    : []
                }
              />
            </div>
          </div>
        </div>
        <div className="tab-content list-grid">
          <div className="tab-pane active" id="list">
            <div className="table-responsive">
              <table className="table" id="accordion">
                <thead>
                  <tr>
                    <th>Task</th>
                    <th>Due date</th>
                    <th>Priority</th>
                    <th>Status</th>
                    <th>Assignee</th>
                    <th>Action</th>
                  </tr>
                </thead>
                {Array.isArray(getallteamtaskslist) &&
                  getallteamtaskslist.map(
                    (item, index) =>
                      Array.isArray(item?.task) &&
                      item?.task.length != 0 && (
                        <tbody
                          key={index}
                          className={`accordion-sec ${Array.isArray(item?.task) && item?.task.length != 0
                            ? "show"
                            : ""
                            } `}
                        >
                          <tr onClick={() => handleOpenAccordion(item.id)}>
                            <td
                              className={`general ${selectedCategory == item.id ? "show" : ""
                                } `}
                              colSpan="6"
                            >
                              <h1>{item?.title}</h1>
                            </td>
                          </tr>
                          {Array.isArray(item?.task) && item?.task.length != 0}
                          {Array.isArray(item?.task) &&
                            item?.task.map((childitem, childindex) => (
                              <tr
                                key={childindex}
                                className={`collapse ${selectedCategory == item.id ? "show" : ""
                                  }`}
                              >
                                <td>{childitem?.title}</td>
                                <td>{getDateFormate(childitem?.due_date)}</td>
                                <td className="priority">
                                  <span className="high">
                                    {childitem?.priority}
                                  </span>
                                </td>
                                <td>
                                  <p
                                    className="assigned justify-content-center"
                                    style={{ maxWidth: "104px", minWidth: 'max-content' }}
                                  >
                                    <span></span>
                                    {childitem?.status == 1
                                      ? "Assigned"
                                      : childitem?.status == 2
                                        ? "In Progress"
                                        : childitem?.status == 3
                                          ? "Completed"
                                          : childitem?.status == 4
                                            ? "Reopened"
                                            : ""}
                                  </p>
                                </td>
                                <td className="carla-img">
                                  <h6>
                                    <img
                                      src={childitem?.profile_image ? childitem?.profile_image : ProfilePic}
                                      alt=""
                                    />
                                    {childitem?.first_name}{" "}
                                    {childitem?.last_name}
                                  </h6>
                                </td>
                                <td>
                                  <div className="action-btn">
                                    <button
                                      onClick={() => {
                                        setitemdata(childitem);
                                        setviewModel(true);
                                        setTaskDetails(item, childitem);
                                      }}
                                      className="btn"
                                    >
                                      <img
                                        src={`${CloudStorage.cloudurl}/Assets/Images/common/dots-vertical.svg`}
                                        alt=""
                                      />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      )
                  )}
              </table>
            </div>
          </div>
        </div>

        <Modal className="popupmodal yes-no" isOpen={taskmodel}>
          <TeamsAddTaskModel
            projectid={projectid}
            setTaskModel={setTaskModel}
          />
        </Modal>
        <Modal className="popupmodal yes-no" isOpen={milestonemodel}>
          <TeamsMilestoneModel
            projectid={projectid}
            setMilestoneModel={setMilestoneModel}
          />
        </Modal>
      </div>
      <div
        className={`teamviewdetail ${viewmodel == true ? "show" : ""}`}
        isOpen={viewmodel}
      >
        <TeamsViewDetailsModel
          taskdetails={taskdetails}
          projectdetails={projectdetails}
          itemdata={itemdata}
          projectid={projectid}
          setviewModel={setviewModel}
        />
      </div>
    </>
  );
}
